import Flex from '@eversports/react-components/primitives/Flex'
import Skeleton from '@eversports/react-components/primitives/Skeleton'

const SkeletonPolicies = () => (
  <Flex flexDirection="column" verticalSpacing="default">
    <Skeleton variant="text" height="24px" width="156px" />
    <>
      <Skeleton variant="text" height="20px" width="182px" />
      <Flex flexDirection="column" verticalSpacing="dense">
        <Flex horizontalSpacing="default">
          <Skeleton variant="rectangular" width="20px" height="20px" />
          <Skeleton variant="text" height="20px" width="182px" />
        </Flex>
        <Flex horizontalSpacing="default">
          <Skeleton variant="rectangular" width="20px" height="20px" />
          <Skeleton variant="text" height="20px" width="182px" />
        </Flex>
      </Flex>
    </>
    <div>
      <Skeleton variant="text" />
      <Skeleton variant="text" />
    </div>
    <div>
      <Skeleton variant="text" />
      <Skeleton variant="text" />
    </div>
  </Flex>
)

export default SkeletonPolicies
